import { useEffect } from 'react';
import SelectOverlay from 'components/Inputs/SelectOverlay';
import { layers } from 'app/spacing';
import { StartAutomationSelect } from '../Common/Automations/StartAutomationButton';

const MobileAutomationSelector = ({
  showSelectedAutomation,
  target,
  onSetVisible,
  scrolled,
  shownScrolled,
  onStartAutomation,
  customObjectId,
}) => {
  useEffect(
    () => {
      if ((scrolled && !shownScrolled) || (!scrolled && shownScrolled)) {
        // makes sure the menus close if scrolled
        onSetVisible(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [scrolled, shownScrolled]
  );

  return (
    <SelectOverlay
      show={showSelectedAutomation}
      target={target}
      onHide={() => {
        onSetVisible(false);
      }}
      zIndexNudge={layers.content(0, 3)}
    >
      <StartAutomationSelect
        customObjectId={customObjectId}
        onApply={onStartAutomation}
        onCancel={() => onSetVisible(false)}
      />
    </SelectOverlay>
  );
};

export default MobileAutomationSelector;
